@if (notification) {
    <div class="snackbar {{ notification.type }}">
        <div class="icon-{{ notification.type }}"></div>
        <p class="description">{{ notification.message }}</p>
        <div class="close-btn-{{ notification.type }}" (click)="closeNotification.emit()"></div>
    </div>
}
